import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SharedTools from '../../lib/SharedTools';
import StringHelper from '../../lib/StringHelper';
import DataService from '../../lib/DataService';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule'

import { Calendar, Icon, Spin, Radio, message, Button, Modal } from 'antd';
import moment from 'moment';

const MAX_FILES_COUNT_FOR_PARENT = 9;
const MAX_FILES_COUNT_FOR_TEACHER = 45;
const MAX_TEXT_COUNT = 150;

export default class CreatePostModule extends React.Component {
  static propTypes = {
    // albumId: PropTypes.number.isRequired,
    userRoleInfo: PropTypes.object,
    // successCallBack: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    let uploadedFiles = props.uploadedFiles;
    uploadedFiles.map((file) => {
      if (file.url) {
        file.isUploaded = true;
      } else {
        file.isUploaded = false;
      }
    })
    // set state
    this.state = {
      // albumId: props.albumId,
      userRoleInfo: props.userRoleInfo,

      recordDate: new Date((new Date()).setHours(0,0,0,0)),
      text: '',
      uploadedFiles,
      uploadingFiles: [],
      preuploadQueue: [],
      uploadFileType: ReactQiniuModule.getFileCategories.IMAGES,    // ReactQiniuModule.getFileCategories.IMAGES or ReactQiniuModule.getFileCategories.VIDEOS
      filesLimit: props.photo_count ? props.photo_count : 45,

      isTagStudents: false,
      tagStudentIds: [],
      isSetVisibility: false,
      classStudents: [],
      isShowStudentsTagging: false,

      calendarMode: 'month',
      isShowCalendar: false,

      isSubmitting: false,

      filesArray: [],
      showSubmitVisible: false,
    };
    // bind this
    this.toolUpdateFilesList = this.toolUpdateFilesList.bind(this);
    this.resubmitUploadFiles = this.resubmitUploadFiles.bind(this);

    this.getAvailableQuotaForUploadingFiles = this.getAvailableQuotaForUploadingFiles.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.onFileUploadError = this.onFileUploadError.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.removeUploadedFile = this.removeUploadedFile.bind(this);
    this.pushFileToPreuploadQueue = this.pushFileToPreuploadQueue.bind(this);
    this.popFileFromQueue = this.popFileFromQueue.bind(this);
    this.isPreuploadQueueEmpty = this.isPreuploadQueueEmpty.bind(this);
  }

  componentWillReceiveProps(newProps) {
    let uploadedFiles = newProps.uploadedFiles;
    uploadedFiles.map((file) => {
      if (file.url) {
        file.isUploaded = true;
      } else {
        file.isUploaded = false;
      }
    })
    this.setState({
      uploadedFiles
    })
  }

  componentDidMount() {
    if (this.state.userRoleInfo && this.state.userRoleInfo.associatName == "student")
      this.parentTagStudent();
  }

  // Tools
  loadClassStudents(classId) {
    if (this.state.classStudents.length <= 0)
      DataService.getStudents(classId).then((response) => {
        this.setState({
          classStudents: response
        })
      }, (error) => {});
  }

  dateToMoment(date) {
    return moment(date);
  }

  getTagStudentsInfo() {
    let description = ' - 全班';
    if (this.state.isTagStudents && this.state.userRoleInfo.associatName !== "student") {
      description = ` - 已选${this.state.tagStudentIds.length}人`;
    }

    return description;
  }

  toolUpdateFilesList(type, newFilesList) {
    if (type == 'uploaded') {
      this.setState({
        uploadedFiles: newFilesList
      });
      this.props.callbackUploadFile(newFilesList, this.props.questionId)
    } else if (type == 'uploading') {
      this.setState({
        uploadingFiles: newFilesList
      });
    }
    return true;
  }

  fileThumb(file) {
    let exName = file.name.split('.').slice(-1)[0];
    if (["png", "jpg", "jpeg", "gif"].indexOf(exName.toLowerCase()) >= 0) {
      return SharedTools.getThumbImageUrl(file.remote_url);
    } else if (["mp4"].indexOf(exName.toLowerCase()) >= 0) {
      return file.remote_url + "?vframe/jpg/offset/0.5";
    }
  }

  getDisplayRecordDate(date) {
    let dateStr = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    let now = new Date();
    if (date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate())
      dateStr = "今天";
    return dateStr;
  }

  // Events
  toggleTaggingStudents() {
    if (this.state.userRoleInfo) {
      if (this.state.userRoleInfo.associatName == "student") {
        if (this.state.isTagStudents)
          this.setState({
            isTagStudents: false
          });
        else
          this.setState({
            isTagStudents: true,
            tagStudentIds: [this.state.userRoleInfo.associatObj.id]
          });
      }
      else {
        this.setState({
          isShowStudentsTagging: !this.state.isShowStudentsTagging
        });
      }
    }
  }

  parentTagStudent() {      // only use for parent
    if (this.state.userRoleInfo) {
      this.setState({
        isTagStudents: true,
        tagStudentIds: [this.state.userRoleInfo.associatObj.id]
      });
    }
  }

  toggleSetVisibility() {
    this.setState({
      isSetVisibility: !this.state.isSetVisibility
    })
  }

  onTextChange(event) {
    this.setState({
      text: event.target.value
    });
  }

  onCalendarSelect(value) {
    if (!this.isCalendarDateSelectable(value))
      this.setState({
        recordDate: new Date(value.format()),
        isShowCalendar: false
      });
  }

  onCalendarPanelChange(value, mode) {
    if (!this.isCalendarDateSelectable(value))
      this.setState({
        recordDate: new Date(value.format()),
        calendarMode: mode
      });
  }

  isCalendarDateSelectable(currentDate) {
    return new Date() < new Date(currentDate.format());
  }

  toggleSelectStudent(event) {
    event.stopPropagation();
    let studentId = parseInt(event.currentTarget.dataset.studentid);
    let index = this.state.tagStudentIds.indexOf(studentId);
    if (index >= 0) {
      this.state.tagStudentIds.splice(index, 1);
    } else {
      this.state.tagStudentIds.push(studentId);
    }
    this.setState({
      tagStudentIds: this.state.tagStudentIds,
      isTagStudents: this.state.tagStudentIds.length > 0,
      isSetVisibility: this.state.tagStudentIds.length <= 0 ? false : this.state.isSetVisibility
    });
  }

  toggleShowCalendar() {
    this.setState({
      isShowCalendar: !this.state.isShowCalendar
    })
  }

  onSubmit() {
    if (this.state.isSubmitting || !this.isAllUploadingFileFinished() || this.state.text.length > MAX_TEXT_COUNT)
      return;
    let uploadedFiles = [];
    this.state.uploadedFiles.forEach((file) => {
      if (file.isUploaded) {
        uploadedFiles.push(file)
      }
    })
    if (this.state.uploadedFiles.length <= 0) {
      message.info("请上传照片或视频");
      return;
    } else if (this.state.uploadedFiles.length > 0 && uploadedFiles <= 0){
      message.info("无有效照片或视频, 请重新上传");
      return;
    }

    this.setState({
      isSubmitting: true
    });
    let timeStamp = new Date((new Date()).setHours(0,0,0,0)) - this.state.recordDate > 0 ? parseInt(this.state.recordDate.getTime() / 1000) : parseInt(Date.now() / 1000);
    let requestData = {
      role: this.state.userRoleInfo.associatName == "student" ? "parent" : "teacher",
      text: !StringHelper.isEmpty(this.state.text) ? this.state.text : (this.state.uploadFileType == ReactQiniuModule.getFileCategories.IMAGES ? "上传照片" : "上传视频"),
      record_date: timeStamp,
    };
    if (this.state.uploadFileType === ReactQiniuModule.getFileCategories.IMAGES)
      requestData.photos = JSON.stringify(uploadedFiles.map((file) => {
        return {url: file.remote_url, ...file.info}
      }));
    else
      requestData.video = JSON.stringify(uploadedFiles.map((file) => {
        return {url: file.remote_url, ...file.info}
      })[0]);
    if (this.state.isTagStudents) {
      requestData.tag_student_ids = JSON.stringify(this.state.tagStudentIds);
      if (this.state.userRoleInfo.associatName !== "student" && this.state.isSetVisibility)
        requestData.visibility_student_ids = JSON.stringify(this.state.tagStudentIds);
    }
    // send request
    DataService.createPost(this.state.albumId, requestData).then((response) => {
      message.success('发布新鲜事成功');
      this.setState({
        isSubmitting: false,
        recordDate: new Date((new Date()).setHours(0,0,0,0)),
        text: '',
        uploadedFiles: [],
        uploadingFiles: [],

        isTagStudents: false,
        tagStudentIds: [],
        isSetVisibility: false,

        isShowStudentsTagging: false,
        isShowCalendar: false
      });
      // callback
      this.props.successCallBack();
    }, (error) => {
      message.error('发布新鲜事失败');
      this.setState({
        isSubmitting: false,
      })
    });
  }

  showSubmitModal(visible, state) {
    this.setState({
      showSubmitVisible: visible
    })
    if (state == 'submit') {
      this.onSubmit()
    } else if (state == 'reupload'){
      this.resubmitUploadFiles()
    }
  }

  // --- upload ---
  /** 上传逻辑说明
  数据存储在三个地方：上传前放在preuploadQueue，上传中的放在uploadingFiles，上传成功的放在uploadedFiles
  preuploadQueue: [{file: 文件对象, key: 文件的一个字符串标识，是上传后url的一部分}]
  uploadingFiles: [key1, key2, ... keyN], 跟preuploadQueue里面的key是一致的
  uploadedFiles: [{name: 文件名, size: 所占磁盘空间大小, remote_url: 七牛CDN的链接,
                  info: {w: 图片或视频的宽, h: 图片或视频的高, length: 视频的长度(秒)，图片没有这个字段信息},
                  key: 加上时间戳的标识，`key#timestamp`}]

  运行逻辑：
  1. pushFileToPreuploadQueue() 会首先被触发，preuploadQueue被更新
  2. popFileFromQueue()被调用，第一个文件从preuploadQueue队列中取出。popFileFromQueue()的调用时机在ReactQiniuModule中掌控
  3. onFileStartUpload()被调用，刚才取出的文件被放到uploadingFiles中。此时页面会显示loading效果，而ReactQiniuModule开始上传
  4. -- 在 ReactQiniuModule 里 --
     4.1 uptoken会先获取。如果获取成功，执行4.2。如果获取失败，onFileUploadError()会被调用
     4.2 向七牛的域名发起post的请求，上传图片的数据。如果上传失败，onFileUploadError()会被调用。
     4.3 在4.2上传成功的情况下，首先onFileUploadSuccess()会被执行，更新uploadingFiles（减少图片）和uploadedFiles（增加图片）。 然后会执行isPreuploadQueueEmpty()判断是否还有图片在队列里没上传。如果有，循环执行4，没有跳到5
  5. 此时应该所有图片都上传完成了，preuploadQueue和uploadingFiles为空

  ^ isAllUploadingFileFinished() 函数在串行上传的模式下是没有用处，只有在并行上传时才会用来判断是否所有图片上传好了（根据uploadingFiles来判断）
  **/
  onUploadFileTypeChange(event) {
    if (this.isAllUploadingFileFinished()) {
      this.setState({
        uploadFileType: event.target.value,
        uploadedFiles: []
      });
    }
  }

  getAvailableQuotaForUploadingFiles() {
    let limit = this.state.uploadFileType != ReactQiniuModule.getFileCategories.IMAGES ? 1 : this.state.filesLimit;
    if (limit && limit > 0)
      return limit - this.state.uploadedFiles.length - this.state.uploadingFiles.length - this.state.preuploadQueue.length;
    else
      return 99999999;
  }

  onFileStartUpload(newFileKey) {
    // check quota limit
    if (this.state.filesLimit && this.state.filesLimit >= 0 && this.state.uploadedFiles.length + this.state.uploadingFiles.length >= this.state.filesLimit)
        return false;
    // check file duplicated
    let exist1 = undefined != this.state.uploadedFiles.find((uploadedFile) => (uploadedFile.key && uploadedFile.key.split("#")[0] == newFileKey ));
    let exist2 = undefined != this.state.uploadingFiles.find((uploadingFile) => uploadingFile.key == newFileKey );
    if (exist1 || exist2)
        return false;

    // update uploadingFiles
    let newFiles = SharedTools.cloneObject(this.state.uploadingFiles);
    newFiles.push(newFileKey);

    return this.toolUpdateFilesList('uploading', newFiles);
  }

  onFileUploadSuccess(newFileKey, fileName, fileSize, remoteUrl, info, errorKey) {
    // console.log("seccess: ", fileName);
    let newFiles = SharedTools.cloneObject(this.state.uploadedFiles);
    let file = {
      key: newFileKey + "#" + Date.now(),
      name: fileName,
      size: fileSize,
      remote_url: remoteUrl,
      info: info,
      isUploaded: true
    };

    // 重新上传成功后删除失败文件
    let index = newFiles.findIndex((file) => (!file.isUploaded && file.key == errorKey));
    if (index >= 0) {
      newFiles.splice(index, 1, file)
    } else {
      newFiles.push({
        key: newFileKey + "#" + Date.now(),
        name: fileName,
        size: fileSize,
        remote_url: remoteUrl,
        info: info,
        isUploaded: true
      });
    }
    // set state: uploaded
    this.toolUpdateFilesList('uploaded', newFiles);

    // set state: uploading
    newFiles = this.state.uploadingFiles.filter((uploadingFileKey) => uploadingFileKey != newFileKey );
    this.toolUpdateFilesList('uploading', newFiles);
  }

  onFileUploadError(fileKey, fileObj, errorKey) {

    let uploadedFiles = SharedTools.cloneObject(this.state.uploadedFiles), filesArray = this.state.filesArray;
    let index = uploadedFiles.findIndex((file) => (!file.isUploaded && file.key == errorKey));
    // 上传失败后避免重复上传
    if (index < 0) {
      uploadedFiles.push({
        key: fileKey,
        isUploaded: false,
        fileName: fileObj.name
      });

      // 存入对象数组
      filesArray.push({
        key: fileKey,
        file: fileObj
      })
      this.setState({
        filesArray: filesArray
      })

      // set state: uploaded
      this.toolUpdateFilesList('uploaded', uploadedFiles);

    }

    let newFiles = this.state.uploadingFiles.filter((uploadingFileKey) => uploadingFileKey != fileKey );
    // console.log(newFiles)
    this.toolUpdateFilesList('uploading', newFiles);
  }

  isAllUploadingFileFinished() {
    return this.state.uploadingFiles.length <= 0;
  }

  removeUploadedFile(index) {
    // e.stopPropagation();
    // let index = this.state.uploadedFiles.findIndex(f => f.key == e.currentTarget.dataset.filekey)
    if (index >= 0) {
      this.state.uploadedFiles.splice(index, 1);
      this.toolUpdateFilesList('uploaded', this.state.uploadedFiles);
    }
  }

  pushFileToPreuploadQueue(object) {
    // console.log("push: ", object);
    this.state.preuploadQueue.push(object);
    this.setState({
      preuploadQueue: this.state.preuploadQueue
    });
  }

  popFileFromQueue() {
    let firstElement = this.state.preuploadQueue.splice(0, 1)[0];
    // console.log("pop: ", firstElement);
    this.setState({
      preuploadQueue: this.state.preuploadQueue
    });
    return firstElement;
  }

  isPreuploadQueueEmpty() {
    return this.state.preuploadQueue.length <= 0;
  }

  getErrorFilesCount(files) {
    return files.filter((file) => !file.isUploaded).length
  }

  resubmitUploadFiles() {
    let uploadedFiles = [];
    this.state.uploadedFiles.map((file, index) => {
      if (!file.isUploaded) {
        let fileObj = this.state.filesArray.find((res) => res.key == file.key);
        this.uploadModuleObj.upload(fileObj.file, fileObj.key);
        this.uploadModuleObj.pushFileToPreuploadQueue = this.pushFileToPreuploadQueue;
        this.uploadModuleObj.popFileFromQueue = this.popFileFromQueue;
        this.uploadModuleObj.isPreuploadQueueEmpty = this.isPreuploadQueueEmpty;
      } else {
        uploadedFiles.push(file)
      }
    })

    this.setState({
      uploadedFiles: uploadedFiles
    })
  }

  // Views
  _studentRelatedView() {
    if (this.state.userRoleInfo && this.state.userRoleInfo.associatName !== "student")
      return (
        <div className="students-related">
          <span className={"description" + (this.state.isTagStudents ? " selected" : "")} onClick={this.toggleTaggingStudents}>发送给谁{this.getTagStudentsInfo()}</span>
          {this.state.isShowStudentsTagging &&
            <div className="students-list-container">
              <div className="students">
                {this.state.classStudents.map((student) =>
                  <span className={"student-item" + (this.state.tagStudentIds.indexOf(student.id) >= 0 ? " selected" : "")}
                        data-studentid={student.id} key={student.id} onClick={this.toggleSelectStudent}>
                    {student.full_name}
                  </span>
                )}
              </div>
              <div className="visibility-setting" onClick={this.toggleSetVisibility}>
                <span className={"icon" + (this.state.isSetVisibility ? " selected" : "")}></span>
                <span className={"description" + (this.state.isSetVisibility ? " selected" : "")}>仅选中宝贝家长可见</span>
              </div>
            </div>
          }
        </div>
      )
    else
      return (
        <div className="students-related">&nbsp;</div>
      )
  }

  _showSubmitModal() {
    return (
      <Modal
          title="确认发送"
          visible={this.state.showSubmitVisible}
          onCancel={this.showSubmitModal.bind(this, false)}
          className="show-submit-modal"
          footer={[
            <Button key="back" size="large" onClick={this.showSubmitModal.bind(this, false, 'submit')}>仍要发送</Button>,
            <Button key="submit" type="primary" size="large" onClick={this.showSubmitModal.bind(this, false, 'reupload')}>
              重新上传
            </Button>,
          ]}
        >
          <p>{'您有' + this.getErrorFilesCount(this.state.uploadedFiles) + (this.state.uploadFileType == 'IMAGES' ? '张照片' : '个视频') + '没有上传成功, 是否继续发送？'}</p>
        </Modal>
    )
  }

  render() {
    return (
      <div className="create-post-module">
        <div className="photos" key={this.state.uploadedFiles.map(file => file.key).join('###')}>
          {this.state.uploadedFiles.map((file, index) => {
            if (file.key) {
              return (
                <div key={`uploaded-${index}`} className={"file-card" + (!file.isUploaded ? " error-uploaded" : "")}>
                  <img src={(file.isUploaded && file.name) ? this.fileThumb(file) : "data:image/png;base64,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"} className="file-img"/>
                  <div className="file-remove" data-filekey={file.key} onClick={this.removeUploadedFile.bind(this, index)}><Icon type="close" /></div>
                  {!file.isUploaded ? <div className="file-name">{file.fileName.length > 14 ? file.fileName.substring(0, 5) + '...' + file.fileName.substring(file.fileName.length - 6, file.fileName.length) : file.fileName}</div> : ''}
                </div>
              )
            } else {
              return (
                <div key={`uploaded-${index}}`} className={"file-card" + (!file.isUploaded ? " error-uploaded" : "")}>
                  <img src={SharedTools.getThumbImageUrl(file.url)} /> 
                  <div className="file-remove" data-filekey={file.key} onClick={this.removeUploadedFile.bind(this, index)}><Icon type="close" /></div>
                </div>
              )
            }

          })}

          {this.state.uploadingFiles.map(file =>
            <div key={`uploading-${file}`} className="file-card uploading">
              <Spin wrapperClassName="spin" />
            </div>
          )}

          {this.state.preuploadQueue.map(fileObj =>
            <div key={`uploading-queue-${fileObj.key}`} className="file-card uploading">
              <Spin wrapperClassName="spin" />
            </div>
          )}

          <ReactQiniuModule
              ref={(uploadModule) => {this.uploadModuleObj = uploadModule;}}
              className={"add-post-photo" + (this.getAvailableQuotaForUploadingFiles() <= 0 ? " hide" : "")}
              onSuccess={this.onFileUploadSuccess}
              onError={this.onFileUploadError}
              onStartPermit={this.onFileStartUpload}
              isAllFinish={this.isAllUploadingFileFinished}
              getUploadQuota={this.getAvailableQuotaForUploadingFiles}
              allowUploadFileTypes={this.state.uploadFileType}
              allowUploadFileSize={15}
              isQueueForUpload={true}
              pushFileToPreuploadQueue={this.pushFileToPreuploadQueue}
              popFileFromQueue={this.popFileFromQueue}
              isPreuploadQueueEmpty={this.isPreuploadQueueEmpty} >
          </ReactQiniuModule>
        </div>
        {this.getErrorFilesCount(this.state.uploadedFiles) > 0 ? <div className="error-massage">您有{this.getErrorFilesCount(this.state.uploadedFiles)}{this.state.uploadFileType == 'IMAGES' ? '张照片' : '个视频'}没有上传成功<div><Button className="resubmit-btn" type="primary" onClick={this.resubmitUploadFiles}>重新上传</Button></div></div> : ''}
        <div className="text-image-text-box">
          <span>最多可添加至{this.state.filesLimit}张</span>
          <span className="text-image-text-length">{this.state.uploadedFiles.length}/{this.state.filesLimit}</span>
        </div >
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/UploadImgModule.jsx